export default "__VITE_ASSET__BvdjDr2Z__"